import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useState } from "react";
import { getWidthFromHeader, renderValueAsJSX } from "../../../../until";
import "../../styles.scss";
import { ListField } from "../../../../api/Customer_V2/customerApi_V2";
import { ICustomerFields } from "../../../../api/salesSericeCustomer/salesSericeCustomerApi";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import FilterHeader from "./Components/FilterHeader";



const dataListFieldsByCustomerRecordActive = [
  {
    id: 99,
    title: "Thông tin bảo hành",
    fields: [
      { id: 1, fieldCode: "representative", fieldLabel: "Người đại diện", inputType: "text", isActive: 1 },
      { id: 2, fieldCode: "contactPhoneNumber", fieldLabel: "Số điện thoại liên hệ", inputType: "text", isActive: 1 },
      { id: 3, fieldCode: "ruleCode1", fieldLabel: "Mã số quy tắc 1", inputType: "text", isActive: 1 },
      { id: 4, fieldCode: "ruleCode2", fieldLabel: "Mã số quy tắc 2", inputType: "text", isActive: 1 },
      { id: 5, fieldCode: "deliveryDate", fieldLabel: "Ngày giao xe", inputType: "text", isActive: 1 },
      { id: 6, fieldCode: "staff", fieldLabel: "Nhân viên", inputType: "text", isActive: 1 },
      { id: 7, fieldCode: "unit", fieldLabel: "Đơn vị", inputType: "text", isActive: 1 }
    ]
  }
];

const dataListFieldsByCustomerRecordNotActive = [
  { id: 99, title: "Thông tin bảo hành", fields: [] }

];

const daumData = [
  {
    id: 1,
    code: "C53343401K1234",
    name: "Xe Đức - Du lịch",
    groupPermissionId: 100,
    fields: [
      { fieldId: 1, fieldCode: "representative", value: "Du lịch" },
      { fieldId: 2, fieldCode: "contactPhoneNumber", value: "53343401K1234" },
      { fieldId: 3, fieldCode: "ruleCode1", value: "Trắng" },
      { fieldId: 4, fieldCode: "ruleCode2", value: "408 20G AT" },
      { fieldId: 5, fieldCode: "deliveryDate", value: "21/02/2022" },
      { fieldId: 6, fieldCode: "staff", value: "075/2025/HĐMB/KIAVL-KH" },
      { fieldId: 7, fieldCode: "unit", value: "00001226" }
    ],
    permissionMenu: { groupPermissionId: 100, view: true, edit: false, delete: false }
  }
];

interface Prop {
  isSettingShow?: boolean;
  activeServiceRecordsTab: string
  setSettingShow?: (isClose: boolean) => void;
}

const WarrantyInformation = ({stData = {} as any}) => {

  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([]);
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([]);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });

  useEffect(() => {
    gListFieldsActive();
  }, []);

  useEffect(() => {
    const codes = dataFilterActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFilterActive]);


  const gListFieldsActive = async () => {
    const flattenedFields = dataListFieldsByCustomerRecordActive.flatMap((choice) =>
      choice.fields.map((field) => ({ ...field, parentId: choice.id }))
    );
    setDataFilterActive(flattenedFields);
    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive);
  };

  const generateColumnsFromCodesAgGridReact = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>,
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void
  ): ColDef[] => {
    const baseColumns = codes
      ?.map((code) => {
        const field = fields.find((f) => f.fieldCode === code);
        if (!field) return null;

        return {
          headerName: field.fieldLabel,
          headerComponent: FilterHeader,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          width: getWidthFromHeader(field.fieldLabel),
          cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
        } as ColDef;
      })
      .filter(Boolean) as ColDef[];

    return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
  };

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      columnsMapShow,
      dataFilterActive,
      undefined,
      (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)
    );
  }, [columnsMapShow, dataFilterActive]);

  const tableData = useMemo(() => {
    return daumData.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, []);


  return (
    <>

      <div className="ag-theme-alpine custom-table-ag custom-page-css" style={{ width: "100%" }}>
        <AgGridReact
          rowData={stData.xesohuu_show && stData.xesohuu_show.vehicle_owner_insurance ? stData.xesohuu_show.vehicle_owner_insurance : []} // Row data for rows, we pass an empty array to show the "No Rows" overlay
          columnDefs={[
            { field: 'ins_code', headerName: 'Mã bảo hiểm' },
            { field: 'ins_commission_insurance', headerName: 'Hoa hồng bảo hiểm' },
            { field: 'ins_date', headerName: 'Ngày mua bảo hiểm' },
            { field: 'ins_name', headerName: 'Công ty bảo hiểm' },
            { field: 'ins_original_insurance_amount', headerName: 'Số tiền mua bảo hiểm' },
            { field: 'ins_sale_employee_name', headerName: 'Nhân viên bán BH' },
            { field: 'ins_times', headerName: 'Thời hạn' },
          ]}
          rowHeight={55}
          domLayout="autoHeight"
        />
      </div>
    </>
  );
};
export default WarrantyInformation;
